export const DEFAULT_MACRO = {
  isActive: true,
  name: '',
  items: []
}

export const INITIAL_MACRO_STATE = {
  isActive: true,
  name: '',
  items: []
}
